import axios from './http'
import de from "element-ui/src/locale/lang/de";

/**
 * 登陆API
 * @type {{logout(): Promise<AxiosResponse<*>>, login(*=, *=): Promise<AxiosResponse<*>>}}
 */
const login = {

  /**
   * 注册
   * verificationCode  为验证码,暂时不用
   * @param user
   * @returns {Promise<AxiosResponse<any>>}
   */
  register(user) {
    return axios.post('/thesis/auth/register?verificationCode=' + "0", user)
  },

  /**
   * 登录
   * @param userName
   * @param password
   */
  login(userName, password) {
    let param = new URLSearchParams()
    param.append('verificationCode', '1')
    param.append('userName', userName)
    param.append('password', password)
    return axios.post('/thesis/auth/login', param)
  },

  /**
   * 登出
   * @returns {Promise<AxiosResponse<any>>}
   */
  logout() {
    return axios.post('/thesis/auth/logout')
  },

  /**
   * 获取验证码
   * @param userPhone 手机号
   */
  verificationCode(userPhone, useType) {
    let param = new URLSearchParams()
    param.append('userPhone', userPhone)
    param.append('useType', useType)
    return axios.post('/thesis/auth/sendMessage', param)
  },

  /**
   * 比对手机验证码 并返回信息
   * @param userPhone
   * @param code
   * @param useType 使用场景 1注册,2登录,3修改密码
   * @param newPassword 场景3有值
   * @param request
   */
  checkMessageCode(userPhone, code, useType, newPassword) {
    let param = new URLSearchParams()
    param.append('userPhone', userPhone)
    param.append('code', code)
    param.append('useType', useType)
    param.append('newPassword', newPassword)
    return axios.post('/thesis/auth/checkMessageCode', param)
  },

  /**
   * 得到微信码
   * @returns {Promise<AxiosResponse<any>>}
   */
  getWeChatCodeOfState() {
    return axios.get('/thesis/auth/getWeChatCodeOfState')
  },

  /**
   * 绑定账户
   * @param request
   * @param state 微信回调时，携带的程序中提前预制的state，在session中有一份
   * @param verifyKey 手机号/用户名
   * @param verifyValue 验证码/密码
   * @param useType 1，手机号验证码方式；2，账户密码方式
   * @return
   * @throws Exception
   */
  bindAccount(state, verifyKey, verifyValue, useType) {
    let param = new URLSearchParams()
    param.append('state', state)
    param.append('verifyKey', verifyKey)
    param.append('verifyValue', verifyValue)
    param.append('useType', useType)
    return axios.post('/thesis/auth/bindAccount', param)
  },

  /**
   * 微信回到code state
   * @param code
   * @param state
   */
  loginCallback(code, state) {
    let param = new URLSearchParams()
    param.append('code', code)
    param.append('state', state)
    return axios.post('/thesis/auth/logincallback', param)
  },

  /**
   * 获取比赛相关的所有信息-用户调用-不需要登录
   */
  getGameInfo() {
    return axios.get('/thesis/auth/getGameInfo')
  },

  /**
   * 返回QQ请求access_token时的state和appid
   * @param request
   * @return
   * @throws Exception
   */
  getQQCodeOfState() {
    return axios.get('/thesis/auth/getQQCodeOfState')
  },

  /**
   * QQ登录回调地址
   * @param session
   * @param code QQ回调的code
   * @param state QQ回调时，携带的程序中提前预制的state，在session中有一份
   * @param request
   * @return
   * @throws Exception
   */
  logincallbackOfQQ(code,state){
    let param = new URLSearchParams()
    param.append('code', code)
    param.append('state', state)
    return axios.post('/thesis/auth/logincallbackOfQQ', param)
  },

  /**
   * QQ绑定账户
   * @param request
   * @param state QQ回调时，携带的程序中提前预制的state，在session中有一份
   * @param verifyKey 手机号/用户名
   * @param verifyValue 验证码/密码
   * @param useType 1，手机号验证码方式；2，账户密码方式
   * @return
   * @throws Exception
   */
  bindAccountOfQQ(state, verifyKey, verifyValue, useType) {
    let param = new URLSearchParams()
    param.append('state', state)
    param.append('verifyKey', verifyKey)
    param.append('verifyValue', verifyValue)
    param.append('useType', useType)
    return axios.post('/thesis/auth/bindAccountOfQQ', param)
  },
}

export default login



// WEBPACK FOOTER //
// ./src/api/login.js